import 'slick-carousel/slick/slick'

export default class FeaturedCaseStudiesSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-featured-case-studies')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                adaptiveHeight: true,
                prevArrow: $('.js-f-case-studies-previous'),
                nextArrow: $('.js-f-case-studies-next'),
                appendDots: $('.js-f-case-studies-dots'),
            });
        }

    }

};

new FeaturedCaseStudiesSlider();